<template>
  <div class="c-tabs">
    <ul class="tab-list">
      <li
        class="tab-list__item"
        :class="{ 'tab-list__item--white-bg': whiteBg,
        'tab-list__item--active': String(c.key) === String(activeKey),
         }"
        v-for="c of config"
        :key="c.key"
        @click="handleTab(c.key)"
      >
        <span class="tab-list__item__text">{{ c.label }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default defineComponent({
  name: 'Tabs',
  props: {
    config: {
      type: Array,
      default: () => [],
    },
    activeKey: {
      type: String,
      default: '',
    },
    whiteBg: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:activeKey'],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const handleTab = (key) => {
      emit('update:activeKey', key);

      router.push({
        name: route.name,
        query: {
          tab: key,
        },
      });
    };

    return {
      handleTab,
    };
  },
});
</script>
<style lang="scss" scoped>
.tab-list {
  &__item {
    @include inline-flex();
    @include font-style($c-main, 16, 400, 1.6px);

    outline: 0px transparent;
    border: 0px transparent;
    background-color: $c-tab-bg;
    cursor: pointer;
    @include padding(0 28px);
    height: 40px;
    border-radius: 20px;

    margin-right: 24px;
    margin-bottom: 20px;
    // box-shadow: 0px 3px 10px #0000001a;

    &--white-bg {
      background-color: $c-white;

    }

    &--active {
      color: $c-main;
      opacity: 1;
      background-color: $c-main-yellow;
    }
  }
}
</style>
